import { storage } from '~/lib/storage';

const initialState = () => ({
  projectSettings: {
    technique: {
      name: '',
      config: [],
    },
  },
  fieldConfig: {
    location: '',
    track: '',
    plot: '',
    coordinate: '',
    inputViews: {
      // id only used as v-for key, new item should use new id as it may conflicted
      // with what the client already used in their local storage
      localName: { id: 0, label: 'Nama Lokal', enabled: true, group: 'general' },
      individuCount: { id: 1, label: 'Jumlah Individu', enabled: false, group: 'counter' },
      habitus: { id: 2, label: 'Habitus', enabled: false, group: 'counter' },
      girth: { id: 3, label: 'Keliling (K)', enabled: false, group: 'measurement' },
      diameter: { id: 4, label: 'Diameter (D)', enabled: false, group: 'measurement' },
      height: { id: 5, label: 'Tinggi Bebas Cabang (TBC)', enabled: false, group: 'measurement' },
      widestCrownHeight: { id: 11, label: 'Tinggi Tajuk Terlebar (TTL)', enabled: false, group: 'measurement' },
      totalHeight: { id: 6, label: 'Tinggi Total (TT)', enabled: false, group: 'measurement' },
      widestCrown: {
        id: 12,
        label: 'Tajuk Terpanjang:\nAzimuth α (∠α PNJG)\nJarak α (⟺α PNJG)\nBack Azimuth β (∠β PNJG)\nJarak β (⟺β PNJG)',
        enabled: false,
        group: 'crown',
      },
      shortestCrown: {
        id: 13,
        label: 'Tajuk Terpendek:\nAzimuth α (∠α PNDK)\nJarak α (⟺α PNDK)\nBack Azimuth β (∠β PNDK)\nJarak β (⟺β PNDK)',
        enabled: false,
        group: 'crown',
      },
      crownDirectionDistance: {
        id: 8,
        label: 'Arah Mata Angin:\nJarak Barat (⇔B)\nJarak Timur (⇔T)\nJarak Utara (⇔U)\nJarak Selatan (⇔S)',
        enabled: false,
        group: 'crown',
      },
      position: { id: 9, label: 'Posisi (x,y)', enabled: false, group: 'others' },
      note: { id: 10, label: 'Note', enabled: false, group: 'others' },
    },
  },
});

const getters = {
  getConfiguredHabitus: (state) => state.projectSettings.technique.config.map((c) => c.habitus).flat(),
  getFieldConfig: (state) => state.fieldConfig,
  getProjectSettings: (state) => state.projectSettings,
  getTechniqueConfig: (state) => state.projectSettings.technique.config ?? [],
  getTechniqueName: (state) => state.projectSettings.technique.name ?? '',
  hasProjectSettings: (state) => !!state.projectSettings.technique.name,
};

const actions = {
  async loadInventumSettings({ commit }) {
    // Migrate to IndexedDB
    const isUsingLocalStorage = window.localStorage.getItem('inventum-field-config');
    let projectSettings = {};
    let fieldConfig = {};
    if (isUsingLocalStorage) {
      projectSettings = JSON.parse(window.localStorage.getItem('inventum-project-settings')) || {};
      fieldConfig = JSON.parse(window.localStorage.getItem('inventum-field-config')) || {};
      await storage.setItemMany([
        ['inventum-project-settings', projectSettings],
        ['inventum-field-config', fieldConfig],
      ]);
      window.localStorage.removeItem('inventum-project-settings');
      window.localStorage.removeItem('inventum-field-config');
    } else {
      projectSettings = (await storage.getItem('inventum-project-settings')) || {};
      fieldConfig = (await storage.getItem('inventum-field-config')) || {};
    }
    // SETTINGS MIGRATION: from N-N to N<x<N
    if (projectSettings.technique?.config) {
      projectSettings.technique.config.forEach((tc) => {
        const matchOldRangeFormat = tc.diameterRange.match(/^(\d+\.?\d*)-(\d+\.?\d*)$/);
        if (matchOldRangeFormat) {
          const [, from, to] = matchOldRangeFormat;
          tc.diameterRange = `${from}<=x<=${to}`;
        }
      });
    }
    // SETTINGS MIGRATION: from crownAngleDistance to widestCrown and shortestCrown
    if (fieldConfig.inputViews?.crownAngleDistance) {
      delete fieldConfig.inputViews.crownAngleDistance;
    }
    commit('SET', {
      projectSettings,
      fieldConfig,
    });
  },
  async saveProjectSettings({ commit }, projectSettings) {
    try {
      await storage.setItem('inventum-project-settings', projectSettings);
    } catch (e) {
      console.warn(e);
    }
    commit('SET', { projectSettings: projectSettings });
  },
  async saveFieldConfig({ commit }, fieldConfig) {
    try {
      await storage.setItem('inventum-field-config', fieldConfig);
    } catch (e) {
      console.warn(e);
    }
    commit('SET', { fieldConfig: fieldConfig });
  },
  reset({ commit }) {
    commit('RESET');
  },
};

const mutations = {
  SET(state, { projectSettings, fieldConfig }) {
    if (projectSettings)
      state.projectSettings = {
        ...initialState().projectSettings,
        ...projectSettings,
      };
    if (fieldConfig)
      state.fieldConfig = {
        ...initialState().fieldConfig,
        ...fieldConfig,
        inputViews: {
          ...initialState().fieldConfig.inputViews,
          ...fieldConfig.inputViews,
        },
      };
  },
  RESET(state) {
    state.projectSettings = {
      ...initialState().projectSettings,
    };
    state.projectSettings = {
      ...initialState().fieldConfig,
    };
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
